import type { Option } from 'fp-ts/Option'

import { pipe } from 'fp-ts/function'
import * as O from 'fp-ts/Option'
import { is } from 'ramda'


const parseSingle = (input: unknown): Option<number> =>
  pipe(
    input,
    O.fromPredicate(is(Number)),
    O.alt(() => O.fromNullable(is(String, input) ? Number(input.replace(/[,_]/g, '')) : NaN)),
    O.chain(prev => isNaN(prev) ? O.none : O.some(prev)),
  )

// parse number for any input, number, numberic string with/out delimiter, array.
export const parseNumber = (input: unknown): Option<number> =>
  pipe(
    input,
    O.fromPredicate(is(Number)),
    O.alt(() => parseSingle(input)),
    O.alt(() => is(Array, input) ? parseSingle(input[0]) : O.none),
    O.chain(prev => isNaN(prev) ? O.none : O.some(prev)),
  )